<template>
  <div>
    <div v-if="!isMediaStreamAPISupported">{{mediaNotSupportedMessage}}</div>
    <div id="interactive" class="viewport scanner">
      <video />
      <canvas class="drawingBuffer" />
    </div>
  </div>
</template>

<script>
  import Quagga from 'quagga';

  export default {
    name: 'QuaggaScanner',
    props: {
      //detected: String,
      startScan: Boolean,
      onDetected: {
        type: Function,
        default(result) {
          const adjustRate = this.adjustmentRate >= 100 ? 99 : this.adjustmentRate <= 0 ? 1 : this.adjustmentRate;
          const errorAdjustRate = (100 - adjustRate) / 100;
          const errors = result.codeResult.decodedCodes
            .filter(_ => _.error !== undefined)
            .map(_ => _.error);

          //let test = 'Err:';
          //result.codeResult.decodedCodes.forEach(_ => {
          //  if (_.error === undefined) test += ' undefined';
          //  else test += ' ' + _.error;
          //});
          //alert(test);

          const median = this.getMedian(errors);

          if (median >= errorAdjustRate) {  //0.10
            // probably wrong
            return;
          }

          //this.$emit('update:detected', result.codeResult.code);
          this.$emit('get-detected-code', result.codeResult.code);
          this.$emit('update:startScan', false);

          //this.stopQuagga();
          //alert(this.detectedCodes[0] + " " + this.detectedCodes[1] + " " + this.detectedCodes[2] + " " + this.detectedCodes[3]);
        },
      },
      onProcessed: {
        type: Function,
        default(result) {
          //let testProcessResultLocal = '';

          let drawingCtx = Quagga.canvas.ctx.overlay;
          let drawingCanvas = Quagga.canvas.dom.overlay;
          if (result) {
            if (result.boxes) {
              //testProcessResultLocal += ' result.boxes: ' + result.boxes.length;

              drawingCtx.clearRect(
                0,
                0,
                parseInt(drawingCanvas.getAttribute('width')),
                parseInt(drawingCanvas.getAttribute('height'))
              );
              result.boxes
                .filter(function (box) {
                  return box !== result.box;
                })
                .forEach(function (box) {
                  Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                    color: 'green',
                    lineWidth: 2,
                  });
                });
            }
            if (result.box) {
              //testProcessResultLocal += ' result.boxe: true';
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
                color: '#00F',
                lineWidth: 2,
              });
            }
            if (result.codeResult && result.codeResult.code) {
              //testProcessResultLocal += ' codeResult: ' + result.codeResult.code;
              //alert(testProcessResultLocal);
              Quagga.ImageDebug.drawPath(
                result.line,
                { x: 'x', y: 'y' },
                drawingCtx,
                { color: 'red', lineWidth: 3 }
              );
            }

            //alert(testProcessResultLocal);
          }
        },
      },
      readerTypes: {
        type: Array,
        default: () => ['code_128_reader', 'ean_reader', 'ean_8_reader'],
      },
      readerSize: {
        type: Object,
        default: () => ({
          width: 640,
          height: 480,
        }),
        validator: o =>
          typeof o.width === 'number' && typeof o.height === 'number',
      },
      aspectRatio: {
        type: Object,
        default: () => ({
          min: 1,
          max: 2,
        }),
        validator: o => typeof o.min === 'number' && typeof o.max === 'number',
      },
      facingMode: {
        type: String,
        default: () => 'environment'
      },
      adjustmentRate: {
        type: Number,
        default: () => 100
      },
      numOfWorkers: {
        type: Number,
        default: () => navigator.hardwareConcurrency
      },
      deviceId: String
    },
    data: function () {
      return {
        quaggaState: {
          inputStream: {
            type: 'LiveStream',
            constraints: {
              width: { min: this.readerSize.width },
              height: { min: this.readerSize.height },
              facingMode: this.facingMode,
              aspectRatio: { min: 1, max: 1 },
            },
          },
          locator: {
            patchSize: 'medium',
            //halfSample: true,
          },
          numOfWorkers: 1,
          frequency: 10,
          decoder: {
            readers: this.readerTypes,
          },
          locate: false,
        },
        isMediaStreamAPISupported: navigator && navigator.mediaDevices,
        mediaNotSupportedMessage: 'Camera is not supported.',
        detectedCodes: ['']
      };
    },
    watch: {
      onDetected: function (newValue, oldValue) {
        if (oldValue) Quagga.offDetected(oldValue);
        if (newValue) Quagga.onDetected(newValue);
      },
      onProcessed: function (newValue, oldValue) {
        if (oldValue) Quagga.offProcessed(oldValue);
        if (newValue) Quagga.onProcessed(newValue);
      },
      startScan: function (newValue, oldValue) {
        //alert(newValue);
        if (newValue) {
          this.initQuagga();
        }
        else {
          this.stopQuagga();
        }
      },
      deviceId: function (newValue, oldValue) {
        //alert(newValue);
        this.stopQuagga();
        this.initCams();
      },
      numOfWorkers: function (newValue, oldValue) {
        //alert(newValue);
        this.stopQuagga();
        this.startScan = false;
        this.initCams();
      },
      readerTypes: function (newValue, oldValue) {
        //alert(newValue[0]);
        this.quaggaState.decoder.readers = newValue;
        this.stopQuagga();
        this.initCams();
      },
      readerSize: function (newValue, oldValue) {
        //alert(newValue.width + " " + newValue.height);
        this.quaggaState.inputStream.constraints.width.min = newValue.width;
        this.quaggaState.inputStream.constraints.height.min = newValue.height;
        this.stopQuagga();
        this.initCams();
      },
    },
    mounted: function () {
      this.initCams();
    },
    destroyed: function () {
      this.stopQuagga();
    },
    methods: {
      initCams() {
        this.quaggaState.numOfWorkers = this.numOfWorkers > 1 ? this.numOfWorkers : this.quaggaState.numOfWorkers;

        if (this.deviceId !== null && this.deviceId !== '') {
          //this.isMediaStreamAPISupported = true;
          this.quaggaState.inputStream.constraints.deviceId = this.deviceId;
        }
        //else {
        //  this.isMediaStreamAPISupported = false;
        //}

        if (this.startScan) this.initQuagga();
      },
      initQuagga: function() {
        if (!this.isMediaStreamAPISupported) return;

        this.detectedCodes = new Array();
        //alert(this.quaggaState.inputStream.constraints.width.min + " x " + this.quaggaState.inputStream.constraints.height.min);
        Quagga.init(this.quaggaState, function (err) {
          if (err) {
            return console.error(err);
          }
          Quagga.start();
        });
        Quagga.onDetected((result) => {
          this.onDetected(result);
        });
        Quagga.onProcessed(this.onProcessed);
      },
      stopQuagga: function () {
        if (!this.isMediaStreamAPISupported) return;

        if (this.onDetected) Quagga.offDetected(this.onDetected);
        if (this.onProcessed) Quagga.offProcessed(this.offProcessed);
        Quagga.stop();
      },
      getMedian: function (arr) {
        arr.sort((a, b) => a - b);
        const half = Math.floor(arr.length / 2);
        if (arr.length % 2 === 1) // Odd length
          return arr[half];
        return (arr[half - 1] + arr[half]) / 2.0;
      }
    }
  };
</script>

<style scoped>
  .viewport {
    position: relative;
    min-height: 50vh;
    /*overflow: hidden;*/
  }

    .viewport canvas,
    .viewport video {
      position: fixed;
      left: 0;
      top: 0;
    }
</style>



// WEBPACK FOOTER //
// EcomCore/Components/InputDevices/QuaggaJsBarcodeScanner.vue